import comp from "./JumpToSection";
export default comp;
